import React, { useState } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DemoParinted from "../../../../../../templates/ApplicationDetails/components/RichTextArea";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

const WhatsNew = () => {
  const [rows, setRows] = useState([]);
  const [category, setCategory] = useState("");
  const [date, setDate] = useState(null);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const userInfo = Digit.UserService.getUser();
  const authToken = userInfo?.access_token || null;

  // ✅ Add record to local state
  const handleAdd = () => {
    if (!category || !description) {
      alert("Please enter both Category and Description.");
      return;
    }

    const newRow = {
      sno: rows.length + 1,
      category,
      updatedDate: date,
      description,
      updatedOn: new Date().toLocaleString(),
    };

    setRows([...rows, newRow]);
    setCategory("");
    setDate(null);
    setDescription("");
  };

  // ✅ Submit API call
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setShowErrors(true);

    try {
      const payload = {
        UserManual: rows.map((row) => ({
          tenantId: "up",
          sno: row.sno.toString(),
          category: row.category,
          updatedDate: row.updatedDate ? row.updatedDate.format("YYYY-MM-DD") : "",
          description: row.description,
          isApproved: "Whats New",
          isSubApproved: "",
          subCategory: "",
          downloadLink: "",
        })),
        RequestInfo: {
          apiId: "Rainmaker",
          authToken,
          userInfo,
          msgId: `${Date.now()}|en_IN`,
        },
      };

      console.log("📦 Payload:", payload);

      await axios.post(`${Urls.UserManualCreate}`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      setOpenDialog(true);
      alert("✅ Data submitted successfully!");
    } catch (error) {
      console.error("❌ API Error:", error);
      alert("Error submitting form. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          🧾 What's New
        </Typography>

        {/* Input Section */}
        <Box display="flex" flexDirection="column" gap={2} mb={3}>
          <Box display="flex" gap={2}>
            <TextField label="Category" value={category} defaultValue={"New"} onChange={(e) => setCategory(e.target.value)} sx={{ flex: 1 }} />

            <DatePicker
              label="Date"
              value={date}
              onChange={(newValue) => setDate(newValue)}
              renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
            />
          </Box>

          <Typography variant="subtitle1">Description :</Typography>
          <DemoParinted content={description} setContent={setDescription} />

          <Box display="flex" gap={2} mt={2}>
            <Button variant="contained" color="primary" onClick={handleAdd} disabled={loading}>
              Add Record
            </Button>

            <Button variant="contained" color="success" onClick={handleSubmit} disabled={rows.length === 0 || loading}>
              {loading ? <CircularProgress size={24} /> : "Submit"}
            </Button>
          </Box>
        </Box>

        {/* Data Table */}
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
              <TableRow>
                <TableCell>
                  <strong>S.No.</strong>
                </TableCell>
                <TableCell>
                  <strong>Category</strong>
                </TableCell>
                <TableCell>
                  <strong>Date</strong>
                </TableCell>
                <TableCell>
                  <strong>Description</strong>
                </TableCell>
                <TableCell>
                  <strong>Updated On</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell>{row.updatedDate ? row.updatedDate.format("DD/MM/YYYY") : ""}</TableCell>
                  <TableCell>
                    <div
                      dangerouslySetInnerHTML={{ __html: row.description }}
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        borderRadius: "4px",
                        backgroundColor: "#fafafa",
                      }}
                    />
                  </TableCell>
                  <TableCell>{row.updatedOn}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </LocalizationProvider>
  );
};

export default WhatsNew;
